import cn from "classnames"
import React, { useState } from "react"
import { formatLocalDate, formatLocalTime } from "swiipe.portal.shared"
import { getLabelForTranslationChangeType } from "../../../services/translationService"
import { ITranslationChange, translationActions } from "../../../store/reducers/translationSlice"
import { syncTranslationChangesThunk } from "../../../store/thunks/translationsThunks"
import useReduxDispatch from "../../../store/useReduxDispatch"
import { ITranslationItem } from "../../../type/translations/ITranslationItem"
import "./TranslationItemChangesBox.scss"

interface ITranslationItemChangesBoxProps {
    item: ITranslationItem
    language: string
    changeForItemAndLanguage?: ITranslationChange
    className?: string
}

const TranslationItemChangesBox = ({ item, changeForItemAndLanguage, language, className }: ITranslationItemChangesBoxProps) => {
    const dispatch = useReduxDispatch()
    const [showOverlay, setShowOverlay] = useState(false)

    const changes = changeForItemAndLanguage?.allChanges ?? []
    if (changes.length === 0) {
        return null
    }
    const defaultText = item.translations.find((t) => t.language === language)?.content
    const changesWithDefault = [...changes, { value: defaultText, type: undefined, created: undefined }]
    const latestChange = changes[0]

    return (
        <div className={cn("translation-item-changes-box", className)}>
            <div
                className={cn("translation-item-changes-box__enabler", {
                    "translation-item-changes-box__enabler--translation-service": latestChange.type === "TranslationService",
                    "translation-item-changes-box__enabler--import": latestChange.type === "Import",
                    "translation-item-changes-box__enabler--user-change": latestChange.type === "UserChange",
                    "translation-item-changes-box__enabler--pending-upload": latestChange.type === "PendingUpload",
                })}
            >
                <span
                    className="translation-item-changes-box__enabler-text"
                    onClick={(e) => {
                        e.preventDefault()
                        setShowOverlay(!showOverlay)
                        return false
                    }}
                >
                    {latestChange.type === "TranslationService" && "D"}
                    {latestChange.type === "Import" && "I"}
                    {latestChange.type === "UserChange" && "M"}
                    {latestChange.type === "PendingUpload" && "U"}
                </span>
                {showOverlay && (
                    <div className={cn("translation-item-changes-box__overlay")}>
                        {changesWithDefault.map((c) => {
                            return (
                                <div
                                    key={c.type ?? "default"}
                                    className={cn("translation-item-changes-box__overlay-item", {
                                        "translation-item-changes-box__overlay-item--translation-service":
                                            c.type === "TranslationService",
                                        "translation-item-changes-box__overlay-item--import": c.type === "Import",
                                        "translation-item-changes-box__overlay-item--user-change": c.type === "UserChange",
                                        "translation-item-changes-box__overlay-item--pending-upload": c.type === "PendingUpload",
                                    })}
                                >
                                    <div className="translation-item-changes-box__overlay-item-info">
                                        <span className="translation-item-changes-box__overlay-item-type">
                                            {!c.type ? "Default" : getLabelForTranslationChangeType(c.type)}:
                                        </span>

                                        {c.created && (
                                            <span className="translation-item-changes-box__overlay-item-created">
                                                {formatLocalDate(c.created, "medium")} {formatLocalTime(c.created, "medium")}
                                            </span>
                                        )}
                                        {!!c.type && (
                                            <span
                                                className="translation-item-changes-box__overlay-item-remove"
                                                onClick={async () => {
                                                    if (confirm("Are you sure you want to remove this change?")) {
                                                        await dispatch(
                                                            translationActions.clearChanges({
                                                                itemIds: [item.id],
                                                                language: language,
                                                                type: c.type,
                                                                created: c.created,
                                                            })
                                                        )

                                                        dispatch(syncTranslationChangesThunk())
                                                    }
                                                }}
                                            >
                                                Remove
                                            </span>
                                        )}
                                    </div>
                                    <div>{c.value}</div>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}

export default TranslationItemChangesBox
